import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { MatButtonToggleChange, MatButtonToggleModule } from '@angular/material/button-toggle';

export interface ToggleOption<T = unknown> {
  label: string;
  value: T;
}

@Component({
  selector: 'spx-toggle-component',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonToggleModule],
})
export class ToggleComponent<T = unknown> {
  public options = input.required<ToggleOption<T>[]>();
  public value = model<T | undefined>(undefined);

  protected onChange(event: MatButtonToggleChange): void {
    this.value.set(event.value);
  }
}
